import React from 'react';

import { ArrowDown, ArrowUp } from 'components/Icons';

import styles from './SectionHeader.module.scss';

export interface SectionHeaderProps {
  headerTitle: string;
  isRolledUp: boolean;
  handleRollUpSection: () => void;
}

const SectionHeader = ({ headerTitle, isRolledUp, handleRollUpSection }: SectionHeaderProps) => {
  return (
    <div className={styles.sectionTitle} onClick={handleRollUpSection}>
      <p>{headerTitle}</p>

      {isRolledUp && (
        <p>
          <ArrowDown className={styles.arrow} />
        </p>
      )}

      {!isRolledUp && (
        <p className={styles.arrowContainer}>
          <ArrowUp className={styles.arrow} />
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
